import InformedIndividualSection from './InformedIndividualsSection';
import InformedIndividualsSectionPDF from './InformedIndividualsSectionPDF';

type ItemType = {
  id: number;
  report: string;
  name: string;
  associated_department: string;
  notification_reason: string;
  date_informed_at: string;
};

type InformedIndividualSectionFactoryProps = {
  pdf?: boolean;
  items?: Array<ItemType>;
  hasInformedIndividuals?: boolean;
  setIsRemove?: (isRemove: boolean) => void;
};

const InformedIndividualSectionFactory = ({
  pdf = false,
  items = [],
  setIsRemove,
  hasInformedIndividuals = false,
}: InformedIndividualSectionFactoryProps) => {
  if (pdf)
    return (
      <InformedIndividualsSectionPDF
        hasInformedIndividuals={hasInformedIndividuals}
        items={items}
      />
    );
  else if (setIsRemove)
    return <InformedIndividualSection setIsRemove={setIsRemove} />;
  else return <InformedIndividualSection />;
};

export default InformedIndividualSectionFactory;
